// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c908287f","634":"af1901e7","678":"cb16f690"}[chunkId] + ".chunk.js";
};